import { Link, usePage } from '@inertiajs/react';

interface PageProps {
    currentRouteName: string | null;
    [key: string]: unknown;
}

interface NavItem {
    name: string;
    route: string;
    url: string;
}

export default function Navigation() {
    const { props } = usePage<PageProps>();
    const currentRouteName = props.currentRouteName;

    const navigationItems: NavItem[] = [
        { name: 'ホーム', route: 'home', url: '/' },
        { name: '出演者紹介', route: 'personality', url: '/personality' },
        { name: 'うみまちガレージ', route: 'umimachi', url: '/umimachi' },
    ];

    return (
        <>
            <div className="inline-flex lg:float-right lg:pe-8">
                <div role="tablist" className="tabs tabs-box border border-gray-700 bg-base-100">
                    {navigationItems.map((item) => (
                        <Link key={item.route} href={item.url} role="tab" className={currentRouteName === item.route ? 'tab tab-active' : 'tab'}>
                            {item.name}
                        </Link>
                    ))}
                </div>
            </div>
        </>
    );
}
